module.exports = __webpack_public_path__ + "5787074e4cb8a621a194c747f6ed3062.png";